import { ScannedCode } from 'app/features/scan-flow/models';
import { getScannedCodeNumbersByCodeType } from 'app/features/scan-flow/utils';

import { RowSelectionItem } from '../models';

export function filterRowsSelectionByRowNumbers({
    rowNumbers,
    rowSelection,
}: {
    rowNumbers: number[];
    rowSelection: RowSelectionItem[];
}) {
    return rowSelection.filter((rowSelectionItem) => rowNumbers.includes(rowSelectionItem.rowNumber));
}

export function filterRowsSelectionByScannedCodes({
    scannedCodes,
    rowSelection,
}: {
    scannedCodes: ScannedCode[];
    rowSelection: RowSelectionItem[];
}) {
    const rowNumbers = getScannedCodeNumbersByCodeType(scannedCodes, 'location');
    return filterRowsSelectionByRowNumbers({ rowNumbers, rowSelection });
}

export function sortRowSelection(list: RowSelectionItem[]) {
    return [...list].sort((r, b) => r.rowNumber - b.rowNumber);
}
